import React, { useState } from 'react'
import * as actions from '../actions'
import { connect } from 'react-redux'
import { Dialog } from '@material-ui/core'
import { ToastContainer } from 'react-toastify'
import { INTERVALO_CORTO } from '../../../config/settings'
import { FORM_PROCESO_CALADO } from '../../../config/forms'
import { reduxForm } from 'redux-form'

// const { Client, NoAuth } = require('whatsapp-web.js')
// import { Client } from 'whatsapp-web.js'
// const { Client } = require('whatsapp-web.js')

function WhatsApp (props) {
  const [open, setOpen] = useState(false)

  const handleClose = () => {
    setOpen(false)
  }

  return (
    <div>
      <ToastContainer autoClose={INTERVALO_CORTO} />
      <div>
        <Dialog
          open={open}
          onClose={handleClose}
          fullWidth
          maxWidth='xl' />
      </div>
    </div>
  )
}

const mapStateToProps = (state) => {
  return {
  }
}

const withRedux = connect(mapStateToProps, actions)

const withReduxForm = reduxForm({
  form: FORM_PROCESO_CALADO,
  enableReinitialize: true,
  keepDirtyOnReinitialize: true,
  destroyOnUnmount: false,
  updateUnregisteredFields: true
})

export default withRedux(withReduxForm(WhatsApp))
